import React from 'react';
import { User, Building, Phone, Mail, MapPin } from 'lucide-react';
import InputField from './common/InputField';

const AgentFields = ({ handleInputChange, errors = {} }) => {
    return (
        <>
            <InputField
                label="Name"
                name="name"
                placeholder="Your Name"
                icon={User}
                required
                error={errors.name}
                onChange={handleInputChange}
            />

            <InputField
                label="Agency Name"
                name="agencyName"
                placeholder="Agency Name"
                icon={Building}
                onChange={handleInputChange}
            />

            <div className="flex flex-col sm:flex-row divide-y sm:divide-y-0 sm:divide-x divide-gray-100">
                <InputField
                    label="Contact"
                    name="contact"
                    type="tel"
                    placeholder="Phone Number"
                    icon={Phone}
                    required
                    error={errors.contact}
                    onChange={handleInputChange}
                />

                <InputField
                    label="Email Id"
                    name="email"
                    type="email"
                    placeholder="Email Address"
                    icon={Mail}
                    onChange={handleInputChange}
                />
            </div>

            <InputField
                label="Agency Address"
                name="agencyAddress"
                placeholder="Address"
                icon={MapPin}
                onChange={handleInputChange}
            />
        </>
    );
};

export default AgentFields;


